<template>
	<div>
		<header id="headernav" v-if="mobile" :class="{sticky:active}">
			<div id="top-header">
				<div class="container">
					<div class="flex flex-center">
						<a :href="main_site_url+''" class="logo honda"><img :src="cdn_url+'/assets/images/logo/honda.svg'" alt="logo"></a>
					</div>
				</div>
			</div>
			<div id="bottom-header" :class="toggleNavClass()">
				<div id="nav">
					<div class="container">
						<div class="flex flex-center">
							<a :href="main_site_url+''" class="logo ahm" style="margin-right: auto;"><img :src="cdn_url+'/assets/images/logo/ahm-putih.svg'" alt="logo"></a>
							<div class="searching flex flex-center">
								<div class="search">
									<span @click="searchBar"><img :src="cdn_url+'/assets/images/icons/search.svg'" alt="search"></span>
								</div>
								<div class="burger" v-bind:class="{open: open}" @click="openMenu">
									<div class="burger-wrapper">
										<span></span>
										<span></span>
										<span></span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- end bottom header -->

			<div id="navbar" v-bind:class="{open: open}">
				<div class="wrap-mobilemenu">
					<div class="wrap-close">
						<div id="close" class="btn_white" @click="openMenu"><i class="ion-chevron-right"></i></div>
					</div>
					<div class="mobile-menu flex">
						<ul class="accordions">
							<li :class="{active : currentpage == 'home'}">
								<div class="linked">
										<a @click="gtmTracker('Home', app_url)" :href="app_url+''">Home</a>
                                </div>
							</li>
							<li :class="{active : currentpage == 'news'}">
								<div class="linked">
										<a @click="gtmTracker('News', app_url+'/news')" :href="app_url+'/news'">News</a>
                                </div>
							</li>
							<li  :class="{active : currentpage == 'gallery-photo'}">
								<div class="linked">
										<a @click="gtmTracker('Gallery', app_url+'/gallery-photo')" :href="app_url+'/gallery-photo'">Gallery</a>
                                </div>
							</li>
							<li  :class="{active : currentpage == 'event'}">
								<div class="linked">
										<a @click="gtmTracker('Event', app_url+'/event')" :href="app_url+'/event'">Event</a>
                                </div>
							</li>
							<li  :class="{active : currentpage == 'hcid'}">
								<div class="linked">
										<a @click="gtmTracker('HCID', app_url+'/hcid')" :href="app_url+'/hcid'">Profile HCID</a>
                                </div>
							</li>
							<!-- <li  :class="{active : currentpage == 'games'}">
								<div class="linked"><a :href="app_url+'/games'">Games</a></div>
							</li> -->
							<li  :class="{active : currentpage == 'kontak-paguyuban'}">
								<div class="linked">
										<a @click="gtmTracker('Kontak Paguyuban', app_url+'/kontak-paguyuban')" :href="app_url+'/kontak-paguyuban'">Kontak Paguyuban</a>
                                </div>
							</li>
							<li  :class="{active : currentpage == 'faq'}">
								<div class="linked">
										<a @click="gtmTracker('FAQ', app_url+'/faq')" :href="app_url+'/faq'">FAQ</a>
                                </div>
							</li>
                            <li class="nav-item">
								<div class="linked">
                                <a @click="gtmTracker('Honda Bikers Day')" target="_blank" href="https://www.hondabikersday.com/">Honda Bikers Day</a>
                                </div>
                            </li>
							<li v-if="login">
								<div class="linked"><a @click="logoutApp">Logout</a></div>
							</li>

						</ul>
					</div>
				</div>
			</div>

			<transition name="searchbar">
				<div id="search-input" v-if="searchDrop">
					<div class="container">
						<form  @submit.prevent="onSubmit()">
							<input name="_token" type="hidden" :value="token">
							<div class="search-wrapper flex-center flex">
								<span><img :src="cdn_url+'/assets/images/icons/search.svg'" alt="search"></span>
								<input type="text" name="search" placeholder="Cari" autocomplete="off" v-model="searchtext">
								<span @click="searchBar" class="close"><img :src="base_url+'/assets/images/icons/close.svg'" alt="close"></span>
							</div>
						</form>
					</div>
				</div>
				<!-- <search-result></search-result> -->
			</transition>
			<!-- search input -->
		</header>
		<!-- mobile menu -->
		<header id="headernav" :class="{sticky:active}" v-else>
			<div id="top-header">
				<div class="container">
					<div class="flex flex-center">
						<a :href="main_site_url+''" class="logo honda"><img :src="cdn_url+'/assets/images/logo/honda.svg'" alt="logo"></a>
						<a :href="main_site_url+''" class="logo ahm" style="margin-left: auto;"><img :src="cdn_url+'/assets/images/logo/ahm.svg'" alt="logo"></a>
					</div>
				</div>
			</div>
			<div id="bottom-header" :class="toggleNavClass()">
				<div id="nav">
					<div class="container">
						<div class="flex flex-center">
							<div class="search">
								<span @click="searchBar"><img :src="cdn_url+'/assets/images/icons/search.svg'" alt="search"></span>
							</div>
							<div class="nav-menu">
								<ul class="nav-menu-item flex flex-center">
									<li class="nav-item visit" :class="{active : currentpage == 'home'}">
										<a @click="gtmTracker('Home', app_url)" :href="app_url+''">Home</a>
									</li>
									<li class="nav-item" :class="{active : currentpage == 'news'}">
										<a @click="gtmTracker('News', app_url+'/news')" :href="app_url+'/news'">News</a>
									</li>
									<li class="nav-item" :class="{active : currentpage == 'gallery-photo'}">
										<a @click="gtmTracker('Gallery', app_url+'/gallery-photo')" :href="app_url+'/gallery-photo'">Gallery</a>
									</li>
									<li class="nav-item" :class="{active : currentpage == 'event'}">
										<a @click="gtmTracker('Event', app_url+'/event')" :href="app_url+'/event'">Event</a>
									</li>
									<li class="nav-item" :class="{active : currentpage == 'hcid'}">
										<a @click="gtmTracker('HCID', app_url+'/hcid')" :href="app_url+'/hcid'">Profile HCID</a>
									</li>
									<!-- <li class="nav-item" :class="{active : currentpage == 'games'}">
										<a @click="gtmTracker('Games', app_url+'/games')" :href="app_url+'/games'">Games</a>
									</li> -->
									<li class="nav-item" :class="{active : currentpage == 'kontak-paguyuban'}">
										<a @click="gtmTracker('Kontak Paguyuban', app_url+'/kontak-paguyuban')" :href="app_url+'/kontak-paguyuban'">Kontak Paguyuban</a>
									</li>
									<li class="nav-item" :class="{active : currentpage == 'faq'}">
										<a @click="gtmTracker('FAQ', app_url+'/faq')" :href="app_url+'/faq'">FAQ</a>
									</li>
									<li class="nav-item">
										<a @click="gtmTracker('Honda Bikers Day')" target="_blank" href="https://www.hondabikersday.com/">Honda Bikers Day</a>
									</li>
								</ul>
							</div>
							<div class="burger" v-bind:class="{open: open}" @click="openMenu">
								<div class="burger-wrapper">
									<span></span>
									<span></span>
									<span></span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- end bottom header -->
			<div class="dropdown-menu" v-bind:class="{open: open}" @click="openMenu">
				<div class="container">
					<div class="wrap-dropmenu">
						<ul class="drop-item-menu">
							<li><h4>lainnya</h4></li>
							<li><a @click="gtmTracker('Help Center', app_url+'/helpcenter')" :href="'/helpcenter'">Help Center</a></li>
							<li><a @click="gtmTracker('News & Events', app_url+'/news-events')" :href="'/news-events'">News & Events</a></li>
							<li><a @click="gtmTracker('Safety Riding', app_url+'/safety-riding')" :href="'/safety-riding'">Safety Riding</a></li>
							<li><a @click="gtmTracker('Racing', app_url+'/racing')" :href="'/racing'">Racing</a></li>
							<li><a @click="gtmTracker('Community', app_url)" :href="app_url" target="_blank">Community</a></li>
						</ul>
					</div>
				</div>
			</div>
			<!-- dropdown-menu -->
			<transition name="searchbar">
				<div id="search-input" v-if="searchDrop">
					<div class="container">
						<form  @submit.prevent="onSubmit()">
							<input name="_token" type="hidden" :value="token">
							<div class="search-wrapper flex-center flex">
								<span><img :src="cdn_url+'/assets/images/icons/search.svg'" alt="search"></span>
								<input type="text" name="search" placeholder="Cari" autocomplete="off" v-model="searchtext">
								<span @click="searchBar" class="close"><img :src="base_url+'/images/close.svg'" alt="close"></span>
							</div>
						</form>
					</div>
				</div>
				<!-- <search-result></search-result> -->
			</transition>
			<!-- search input -->
		</header>
		<!-- desktop menu -->

	</div>
</template>

<script>
	import { isMobile } from 'mobile-device-detect';
	import VueTypeahead from 'vue-typeahead';
	export default	{
		extends: VueTypeahead,
		data: function() {
			return{
                cdn_url: cdn_url,
				isMobile: isMobile,
				base_url:'',
				app_url:'',
                main_site_url:'',
				open: false,
				currentaccordion: true,
				isDropped: false,
				isDroppedCorporate: false,
				drop: false,
				dropCorporate: false,
				searchDrop: false,
				active: false,
				mobile: false,
				searchtext:'',
                login:auth,
                currentpage:'home',
				token:token
			}
		},
		created(){
			this.base_url = base_url;
			this.app_url = app_url;
            this.main_site_url = main_site_url;
			this.mobile = isMobile;
            const pathArray = window.location.pathname.split("/");
            if(pathArray[2]){
                this.currentpage = pathArray[2];
            }else{
                this.currentpage = 'home';
            }
            console.log(this.currentpage );
		},
		methods: {
			gtmTracker(menu, pageUrl = null) {
				var data = {
					'event': 'menuClick',
					'eventDetail.category': 'Custom Event',
					'eventDetail.action':'Main Menu Click',
					'eventDetail.label': menu,
					// 'pageURL': pageUrl !== null ? pageUrl : window.location.href
					'pageURL': window.location.href
				}
				console.log(data);
				dataLayer.push(data);
			},
			toggleNavClass(){
				if(this.active == false){
					return 'nav-header'
				} else {
					return 'sticky-nav'
				}
			},
			openMenu(){
				this.open = !this.open;
				this.isDropped = false;
				this.isDroppedCorporate = false;
			},
			subMenu(id){
				this.currentaccordion = id;
			},
			dropIt(){
				this.isDropped = !this.isDropped;
				this.isDroppedCorporate = false;
				this.dropCorporate = false;
				this.open = false;
			},
			dropItCorporate(){
				this.isDroppedCorporate = !this.isDroppedCorporate;
				this.dropCorporate = !this.dropCorporate;
				this.isDropped = false;
				this.open = false;
			},
			searchBar(){
				this.searchDrop = !this.searchDrop;
			},
			searchBar(){
				this.searchDrop = !this.searchDrop;
			},
			getdataSearch() {
	            axios.post('/search-result', { params: { search: this.search } });
	                // .then(response => this.results = console.log(response.data))
	                // .catch(error => {});
	        },
			onSubmit(){
				window.location.href = this.buildQuery();
			},
			buildQuery() {
			var inputs = {query:this.searchtext,
						}
			return this.buildUrl(`/search`,inputs);
			},
			buildUrl(url, parameters){
				var qs = "";
				for(var key in parameters) {
					var value = parameters[key];
					if (value) {
						qs += encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&";
					}
				}
				if (qs.length > 0){
					qs = qs.substring(0, qs.length-1);
					url = url + "?" + qs;
				}else{
				url = url +'?limit=9';
				}
				return url;
			},
			logoutApp(){
				localStorage.clear();
				window.location.href = app_url+'/logout';
			}


		},
		mounted(){
			window.document.onscroll = () => {
				let navBar = document.getElementById('bottom-header');
				if (navBar) {
					if (window.scrollY > navBar.offsetTop) {
						this.active = true;
					} else {
						this.active = false;
					}
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	header{
		position: relative;
		z-index: 900;
	}
	.logo{
		img{
			width: 100%;
		}
	}
	.honda{
		width: 320px;
	}
	.ahm{
		width: 160px;
	}
	#top-header{
		padding: 1.5em 0;
		position: relative;
		z-index: 10;
		background-color: #fff;
	}
	#bottom-header{
		background-color: #E61B33;
		position: relative;
		z-index: 10;
	}
	.search{
		margin-right: auto;
	}
	.nav-menu{
		position: relative;
		padding-right: 15px;
		border-right: solid 1px #fff;
		margin-right: 15px;
	}
	.nav-menu .nav-menu-item{
		padding-left: 0;
		margin-bottom: 0;
		margin-top: 0;
	}
	.nav-menu .nav-menu-item .nav-item{
		list-style-type: none;
		padding: 0 15px;
		position: relative;
		cursor: pointer;
	}
    .nav-menu .nav-menu-item .nav-item.active:before,.nav-menu .nav-menu-item .nav-item:hover:before{
        content: "";
        width: 6px;
        height: 6px;
        background-color: #fff;
        border-radius: 100px;
        position: absolute;
        bottom:10px;
        left: 50%;
        margin: 0 0 0 -3px;
    }
	.nav-menu .nav-menu-item .nav-item a{
		color: #fff;
		text-transform: capitalize;
		font-size: 15px;
		font-weight: 700;
        display: block;
        line-height: 55px;
		// font-family: 'Epilogue', sans-serif;
	}
    .nav-menu .nav-menu-item .nav-item a:hover{

    }
	.nav-menu .nav-menu-item .nav-item a span{
		margin-left: 5px;
		font-size: 12px;
		display: inline-block;
		-webkit-transition: .4s ease-in-out;
		-moz-transition: .4s ease-in-out;
		-o-transition: .4s ease-in-out;
		transition: .4s ease-in-out;
	}
	.nav-menu .nav-menu-item .nav-item a.drop span{
		transform: rotate(-180deg);
	}
	.nav-menu .nav-menu-item .nav-item a.dropCorporate span{
		transform: rotate(-180deg);
	}
	.sub-menu-drop{
		position: absolute;
		width: 220px;
		top: 35px;
		margin: 0;
		border:  solid 1px #DBDBDB;
		-webkit-transform-origin: top;
		transform-origin: top;
		-webkit-transition: -webkit-transform .4s ease-in-out;
		transition: -webkit-transform .4s ease-in-out;
		transition: transform .4s ease-in-out;
		transition: transform .4s ease-in-out, -webkit-transform .4s ease-in-out;
		overflow: hidden;
		background-color: #fff;
		padding: 15px 20px;
		left: 50%;
		-webkit-transform: scaleY(1) translateX(-50%);
		transform: scaleY(1) translateX(-50%);
	}
	.nav-menu .nav-item .sub-menu-drop li a{
		color: #727272;
		font-size: 14px;
	}
	.nav-menu .nav-item .sub-menu-drop li{
		margin-bottom: 15px;
		list-style-type: none;
	}
	.nav-menu .nav-item .sub-menu-drop li:last-child{
		margin-bottom: 0;
	}
	.drop-enter, .drop-leave-to{
	-webkit-transform: scaleY(0) translateX(-50%);
	}
	#search-input{
		background-color: #282828;
		display: block;
		position: absolute;
		width: 100%;
		-webkit-transform-origin: top;
		transform-origin: top;
		-webkit-transition: -webkit-transform .4s ease-in-out;
		transition: -webkit-transform .4s ease-in-out;
		transition: transform .4s ease-in-out;
		transition: transform .4s ease-in-out, -webkit-transform .4s ease-in-out;
		overflow: hidden;
	}
	.searchbar-enter, .searchbar-leave-to{
		-webkit-transform: scaleY(0);
	}
	.search-wrapper.flex-center{
		justify-content: space-between;
		padding: 10px 0;
	}
	.search-wrapper span.close{
		cursor: pointer;
	}
	.search-wrapper{
		position: relative;
	}
	.search-wrapper input{
		width: 90%;
		font-size: 14px;
		background: transparent;
		box-shadow: none;
		border-top: none;
		border-left: none;
		border-right: none;
		color: #fff;
		border-bottom: solid 1px #fff;
	}
	/* ======================= BURGER MENU ======================= */
	.burger{
	position: relative;
	cursor: pointer;
	padding-left: 15px;
	}
	.burger-wrapper{
	width: 45px;
	height: 20px;
	position: relative;
	-webkit-transform: rotate(0deg);
	-moz-transform: rotate(0deg);
	-o-transform: rotate(0deg);
	transform: rotate(0deg);
	-webkit-transition: 2s ease-in-out;
	-moz-transition: 2s ease-in-out;
	-o-transition: 2s ease-in-out;
	transition: 2s ease-in-out;
	cursor: pointer;
	}
	.burger-wrapper span{
	display: block;
	position: absolute;
	height: 3px;
	width: 100%;
	max-width: 30px;
	background: #fff;
	opacity: 1;
	right: 0;
	-webkit-transform: rotate(0deg);
	-moz-transform: rotate(0deg);
	-o-transform: rotate(0deg);
	transform: rotate(0deg);
	-webkit-transition: .25s ease-in-out;
	-moz-transition: .25s ease-in-out;
	-o-transition: .25s ease-in-out;
	transition: .25s ease-in-out;
	}
	.burger-wrapper span:nth-child(1){
	top: 0px;
	}

	.burger-wrapper span:nth-child(2){
	top: 8px;
	}

	.burger-wrapper span:nth-child(3) {
	top: 16px;
	}
	.burger.open span:nth-child(1){
	top: 12px;
	-webkit-transform: rotate(135deg);
	-moz-transform: rotate(135deg);
	-o-transform: rotate(135deg);
	transform: rotate(135deg);
	}
	.burger.open span:nth-child(2){
	opacity: 0;
	/* left: 0; */
	}
	.burger.open span:nth-child(3){
	top: 12px;
	-webkit-transform: rotate(-135deg);
	-moz-transform: rotate(-135deg);
	-o-transform: rotate(-135deg);
	transform: rotate(-135deg);
	}
	.dropdown-menu{
		position: absolute;
		top: -200%;
		left: 0;
		right: 0;
		width: 100%;
		height: auto;
		background-color: rgba(255, 255, 255, .95);
		/* opacity: 0; */
		z-index: -1;
		-webkit-transition: 1s ease-in-out;
		-moz-transition: 1s ease-in-out;
		-o-transition: 1s ease-in-out;
		transition: 1s ease-in-out;
		border: solid 1px #000;
	}
	.dropdown-menu.open{
		top: 100%;
		/* opacity: 1; */
		z-index: 1;
		display: block;
		-webkit-animation: expand 1s;
	}
	// @-webkit-keyframes expand{
	// 	0%{top:-200%}
	// 	100%{top:100%}
	// }
	/* ========================================== */
	.drop-item-menu{
		margin: 0;
		padding: 0;
	}
	.wrap-dropmenu{
		position: relative;
		padding: 2em 0;
	}
	.drop-item-menu li h4{
		margin-top: 0;
		margin-bottom: 1.5em;
		color: #282828;
		font-size: 16px;
		font-weight: 600;
		text-transform: capitalize;
	}
	.drop-item-menu li{
		margin-bottom: 20px;
		list-style-type: none;
	}
	.drop-item-menu li:last-child{
		margin-bottom: 0;
	}
	.drop-item-menu li a{
		color: #727272;
		text-transform: capitalize;
		font-size: 14px;
		&:hover {
			color: #E61B33;
		}
	}
	.nav-menu .nav-menu-item .nav-item .sub-menu-drop a:hover{
			color: #E61B33;
	}
	.search span{
		display: inline-block;
		cursor: pointer;
	}
	#headernav.sticky{
		#bottom-header{
			height: auto;
			/* opacity: 0; */
			z-index: -1;
			-webkit-transition: 1s ease-in-out;
			-moz-transition: 1s ease-in-out;
			-o-transition: 1s ease-in-out;
			transition: 1s ease-in-out;

		}
		.dropdown-menu.open{
			position: fixed;
			top: 51px;
			left: 0;
			-webkit-animation: expand2 1s;
		}
	}
	// @-webkit-keyframes expand2{
	// 	0%{top:-100%}
	// 	100%{top:51px}
	// }
	// @-webkit-keyframes expand{
	// 	0%{top:-200%}
	// 	100%{top:100%}
	// }
	/* ========================================== */
	.drop-item-menu{
		margin: 0;
		padding: 0;
	}
	.wrap-dropmenu{
		position: relative;
		padding: 2em 0;
	}
	.drop-item-menu li h4{
		margin-top: 0;
		margin-bottom: 1.5em;
		color: #282828;
		font-size: 16px;
		font-weight: 600;
		text-transform: capitalize;
	}
	.drop-item-menu li{
		margin-bottom: 20px;
		list-style-type: none;
	}
	.drop-item-menu li:last-child{
		margin-bottom: 0;
	}
	.drop-item-menu li a{
		color: #727272;
		text-transform: capitalize;
		font-size: 14px;
	}
	.search span{
		display: inline-block;
		cursor: pointer;
	}
	#bottom-header.sticky-nav{
		transition: all ease-in-out 1s;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		box-shadow: 1px 3px 20px rgba(60,64,67,.2), 0 -5px 0 3px rgba(60,64,67,.149);
		z-index: 99999;
	}
	#headernav.sticky{
		.dropdown-menu.open,
		#search-input{
			position: fixed;
			top: 51px;
			left: 0;
		}
	}
	// ==================================================  MOBILE RESPONSIVE
	@media (max-width: 490px){
        #bottom-header{
            padding:15px 0;
        }
        .logo.ahm{
			max-width: 80px;
		}
		#headernav.sticky{
			.dropdown-menu.open,
			#search-input{
				position: fixed;
				top: 49px;
				left: 0;
			}
			#search-input{
				.search-wrapper{
					.close{
						position: absolute;
						right: 0;
						width: 12px;
					}
					span:first-child{
						width: 20px;
					}
				}
			}
		}
		#search-input{
			.search-wrapper{
				span{
					width: 12px;
				}
			}
		}
		// ======================= MOBILE MENU FIXED
		.wrap-close{
			display: block;
			width: 100%;
			padding: 20px;
			background-color: #E61B33;
				#close{
					// position: absolute;
					// left: 15px;
					// top: 15px;
					font-size: 2em;
					line-height: 40px;
					height: 40px;
					width: 40px;
					text-align: center;
					display: flex;
					justify-content: center;
					align-items: center;
					z-index: 999;
					color: #fff;
				}
		}
		#navbar{
			position: fixed;
			width: 100%;
			top: 0;
			right: -100%;
			overflow-x: hidden;
			height: 100%;
			transition: 0.9s;
			z-index: 99999;
			opacity: 0;
		}
		#navbar.open{
			display: block;
			right: 0;
			transition: 0.9s;
			opacity: 1;
			box-shadow: 0px -5px 16px 0px rgba(0, 0, 0, 0.75);
			background:rgba(0, 0, 0, .5);
		}
		.wrap-mobilemenu{
			height: 100%;
			overflow-y: scroll;
			background-color:#fff;
			max-width: 80%;
			margin-left: auto;
		}
		.mobile-menu{
			justify-content: center;
			position: relative;
			padding-top: 1em;
			max-width: 85%;
			margin: 0 auto;
			overflow-y: scroll;
    		padding-bottom: 8em;
		}
		.accordions {
			width: 100%;
			list-style-type: none;
			padding-left: 0;
		}
		.accordions .linked {
			cursor: pointer;
			padding: 0px 15px 10px 0px;
			margin-top: 20px;
			color: #4F4F4F;
			text-transform: capitalize;
			letter-spacing: 1.25px;
			font-weight: 600;
			// border-bottom: 1px solid #fff;
			position: relative;
			-webkit-transition: all 0.4s ease;
			-o-transition: all 0.4s ease;
			transition: all 0.4s ease;
				a{
					font-size: 15px;
				}
				span{
					font-size: 15px;
					font-weight: 600;
				}
		}
		.accordions .linked a{
			color: #4F4F4F;
		}
		.accordions li i {
			display: block;
			z-index: 100;
			margin-left:auto;
			font-size: 18px;
			-webkit-transition: all 0.4s ease;
			-o-transition: all 0.4s ease;
			transition: all 0.4s ease;
		}
		li.open .linked i{
			transform: rotate(90deg)
		}
		.accordions li .submenu.open {
			display: block;
			-webkit-animation-name: slideInDown;
			animation-name: slideInDown;
			-webkit-animation-duration: 1s;
			animation-duration: 1s;
			-webkit-animation-fill-mode: both;
			animation-fill-mode: both;
		}
		/**
		* Submenu
		-----------------------------*/
		.submenu {
			display: none;
			font-size: 14px;
			margin: 15px 0;
			padding-left: 15px;
			list-style-type: none;
			border-left: solid 1px #DBDBDB;
		}
		.submenu a {
			display: block;
			text-decoration: none;
			padding: 10px 0;
			font-size: 13px;
			padding-left: 15px;
			font-weight: 400;
			color: #4F4F4F;
			-webkit-transition: all 0.25s ease;
			-o-transition: all 0.25s ease;
			transition: all 0.25s ease;
		}
		.cta-btn{
			margin-top: 20px;
		}
		@keyframes slideInUp {
			from {
				-webkit-transform: translate3d(0, 100%, 0);
				transform: translate3d(0, 100%, 0);
				visibility: visible;
			}

			to {
				-webkit-transform: translate3d(0, 0, 0);
				transform: translate3d(0, 0, 0);
			}
		}
		@keyframes slideInDown {
			from {
				-webkit-transform: translate3d(0, -100%, 0);
				transform: translate3d(0, -100%, 0);
				visibility: visible;
			}

			to {
				-webkit-transform: translate3d(0, 0, 0);
				transform: translate3d(0, 0, 0);
			}
		}
		// END MOBILE HAMBURGER---------------
		.spacer{
			display: block;
			margin: 2em 0;
			content: '';
			border: solid 1px #DBDBDB;
			width: 100%;
		}

    }
</style>